import { render, staticRenderFns } from "./HomeDefault.vue?vue&type=template&id=5c79ee0c"
import script from "./HomeDefault.vue?vue&type=script&lang=ts"
export * from "./HomeDefault.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports